import { ReactNode } from 'react'
import { initMainClient } from 'primsell-shared-layer/api/api.interceptors'
import { apiClientMainServiceMiddleware } from 'api'

const Bootstrap = ({ children }: { children: ReactNode }): JSX.Element => {
  initMainClient(apiClientMainServiceMiddleware)

  return <>{children}</>
}

export { Bootstrap }
